import client from './client'
import type { CrowdWorker } from '../types'

export interface AuthResponse {
  worker: CrowdWorker
  access_token: string
  token_type: string
}

export async function authenticateTelegram(initData: string): Promise<AuthResponse> {
  const res = await client.post('/v1/crowd/auth/telegram', { init_data: initData })
  return res.data
}

/** Dev only — calls /v1/crowd/auth/dev-mock (only works when backend DEBUG=True) */
export async function devMockAuth(): Promise<AuthResponse> {
  const res = await client.post('/v1/crowd/auth/dev-mock')
  return res.data
}
